import React from 'react';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ImageElementStockImagesCard from './ImageElementStockImagesCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';
import ImageElementStockImagesLoadMoreCard from './ImageElementStockImagesLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    imagesContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 146;
const galleryCardHeight = 146;

const ImageElementStockImagesContainer = (props) => {
    const { classes, imageElementStockImagesInitializing, imageElementStockImages, imageElementStockImagesAllCount, onImageSelect } = props;

    return (
        <Grid className={classes.imagesContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {imageElementStockImagesInitializing ?
                    <Grid className={classes.galleryProgress}>
                        <CircularProgress />
                    </Grid>
                :
                    imageElementStockImages && imageElementStockImages.length
                    ?
                        <>
                            {imageElementStockImages.map((image, index) =>
                                <ImageElementStockImagesCard
                                    key={image.id}
                                    index={index}
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                    onImageSelect={onImageSelect}
                                />
                            )}

                            {imageElementStockImages.length < imageElementStockImagesAllCount &&
                                <ImageElementStockImagesLoadMoreCard
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            }
                        </>
                    :
                    <EmptyGalleryLabel />
                }
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementStockImages,
        imageStockImages,
        imageElementStockImagesAllCount,
        imageStockImagesAllCount,
        imageElementStockImagesInitializing,
        imageStockImagesInitializing
    } = state.mediaPicker;

    return {
        imageElementStockImages: imageElementStockImages || imageStockImages || [],
        imageElementStockImagesAllCount: imageElementStockImagesAllCount ?? imageStockImagesAllCount ?? 0,
        imageElementStockImagesInitializing: imageElementStockImagesInitializing ?? imageStockImagesInitializing ?? false
    };
};

export default connect(mapStateToProps, {})(withStyles(ImageElementStockImagesContainer, styles));
